<template>
<div>

  <!-- Begin Title Bar -->
  <v-toolbar tile elevation="2">
    <v-toolbar-title>{{ $t('nav.orderDetails') }}</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn icon v-if="initializationDone" @click="$router.go(-1)">
      <v-icon class="color-green">mdi-arrow-left</v-icon>
    </v-btn>
    <v-btn icon v-if="initializationDone" @click="refresh">
      <v-icon class="color-green">mdi-refresh</v-icon>
    </v-btn>

  </v-toolbar>
  <!-- End Title Bar -->

  <div class="app-content">

    <Preloader v-show="!initializationDone" />

    <div v-if="initializationDone" class="main-content">

      <div v-if="parsedOrder">
        <OrderSummary
          showfillorder
          showdeletelink
          initialorderstatechecking
          :parsedOrder="parsedOrder"
          :myaddress="network.userAccount" :myaccount="account"
          :accounturl="config.network[network.id].accountURL"
          :tokenurl="config.network[network.id].tokenURL"
          :txurl="config.network[network.id].txURL"
          v-on:delete-order-complete="checkDelete($event)"
        />
      </div>

      <div v-else class="empty-page-content text-center">
        <div class="mb-3">{{ $t('compOrderSummary.orderNotFound') }}</div>
          <BackButton></BackButton>
      </div>

    </div>

  </div><!-- app-content -->

</div>
</template>

<script>
import { config } from '@/config'
import { BigNumber } from '@0x/utils'
import {mapActions, mapGetters, mapState} from 'vuex'
import OrderSummary from "@/components/OrderSummary"
import BackButton from "@/components/BackButton"
import { getAssetAddressFromAssetData } from '@/utils/utils'
import Preloader from "@/components/Preloader"
import { HttpClient } from '@0x/connect'

export default {
  name: 'OrderDetails',
  data () {
    return {
      config: config,
      parsedOrder: null,
      orderHash: this.$route.params.orderHash,
      initializationDone: false
    }
  },
  computed: {
    ...mapGetters({
      network: 'getNetwork',
      account: 'getAccount',
      tokenInfo: 'getTokenInfo',
      myAddress: 'getUserAccount',
      web3Wrapper: 'getWeb3Wrapper',
      providerEngine: 'getProviderEngine',
      contractWrappers: 'getContractWrappers',
      contractAddresses: 'getContractAddresses',
      networkConfig: 'getNetworkConfig',
    }),
  },
  components: {
    OrderSummary,
    Preloader,
    BackButton
  },
  methods: {
    ...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount', 'parseSignedOrder', 'getTokenInfoByAssetData']),

    /* ------------------------------------------------------ */
    async init () {
      this.initializationDone = false
      await this.loadNetwork()
      await this.loadTokenInfo()
      await this.loadAccount()
      await this.loadOrder()
      this.initializationDone = true
    },

    async refresh () {
      this.init();
    },

    async loadOrder () {
      const apiURL = this.networkConfig.backendSRAHttpURL
      const httpClient = new HttpClient(apiURL)
      let apiResult = null
      try {
        apiResult = await httpClient.getOrderAsync(this.orderHash)
        // console.log(apiResult)
      } catch (err) {
        console.log(err)
        return
      }

      const order = apiResult.order

      try {
        this.parsedOrder = await this.parseSignedOrder(order)
      } catch (err) {
        console.log(err)
      }

    },

    showOrderJson (order) {
      order.showJson = true
    },

    hideOrderJson (order) {
      order.showJson = false
    },

    checkDelete (orderHash) {
      if (orderHash == this.orderHash) {
        this.$router.push({ name: 'MyOrders'})
      }
    }

  },
  created () {
    this.init()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
